export default __webpack_public_path__ + "static/media/coin.e41376ff.svg";